module.exports = __webpack_public_path__ + "static/media/d5f507c68d692504f2f10c68c981cf29c32ceb1e-24x24.59d6aed1.png";